/* Dundon homepage campaign slot (sections/dm-home-campaign.liquid).
   The server already painted the right state; this keeps it right while the
   page stays open and across a cached page that outlives the start or end
   minute. It ticks the countdown, swaps the label, reveals a slot that was
   waiting for its start, hides one that has ended (unless it should stay),
   and adds or removes the rule that hides the trust strip. */
(function () {
  'use strict';

  function track(name, params) {
    if (typeof window.dmTrack === 'function') window.dmTrack(name, params);
  }

  function pad(value) {
    return value < 10 ? '0' + value : String(value);
  }

  function Campaign(root) {
    this.root = root;
    this.start = parseInt(root.getAttribute('data-start'), 10) || 0;
    this.end = parseInt(root.getAttribute('data-end'), 10) || 0;
    this.finalWindow = parseInt(root.getAttribute('data-final-window'), 10) || 0;
    this.preview = root.getAttribute('data-preview') || 'auto';
    this.showPre = root.getAttribute('data-show-pre') === 'true';
    this.showEnded = root.getAttribute('data-show-ended') === 'true';
    this.trustAnchor = root.getAttribute('data-trust-anchor') || '';
    this.name = root.getAttribute('data-name') || '';
    this.state = root.getAttribute('data-state') || 'live';
    this.viewed = false;
    try {
      this.labels = JSON.parse(root.getAttribute('data-labels') || '{}');
    } catch (error) {
      this.labels = {};
    }
    this.label = root.querySelector('[data-dmh-clock-label]');
    this.status = root.querySelector('[data-dmh-clock-status]');
    this.units = {};
    var self = this;
    Array.prototype.forEach.call(root.querySelectorAll('[data-dmh-unit]'), function (node) {
      self.units[node.getAttribute('data-dmh-unit')] = node;
    });
    this.init();
  }

  Campaign.prototype.resolve = function (now) {
    if (this.preview !== 'auto') return this.preview;
    if (now < this.start) return 'pre';
    if (now >= this.end) return 'ended';
    if (this.finalWindow > 0 && this.end - now <= this.finalWindow) return 'final';
    return 'live';
  };

  Campaign.prototype.init = function () {
    var self = this;

    this.root.addEventListener('click', function (event) {
      var cta = event.target.closest ? event.target.closest('[data-dmh-campaign-cta]') : null;
      if (cta) track('campaign_cta_click', { name: self.name, label: cta.getAttribute('data-label') || '' });
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !self.viewed && !self.root.hidden) {
            self.viewed = true;
            track('campaign_view', { name: self.name, state: self.state });
            observer.disconnect();
          }
        });
      }, { threshold: 0.5 });
      observer.observe(this.root);
    }

    this.tick();
  };

  Campaign.prototype.tick = function () {
    var self = this;
    var now = Math.floor(Date.now() / 1000);
    var state = this.resolve(now);
    this.apply(state);

    var target = state === 'pre' ? this.start : this.end;
    var remaining = Math.max(0, target - now);

    // A forced preview keeps the digits the server synthesised for it.
    if (this.preview === 'auto') {
      var days = Math.floor(remaining / 86400);
      var hours = Math.floor((remaining % 86400) / 3600);
      var minutes = Math.floor((remaining % 3600) / 60);
      var seconds = remaining % 60;
      if (this.units.days) this.units.days.textContent = pad(days);
      if (this.units.hours) this.units.hours.textContent = pad(hours);
      if (this.units.minutes) this.units.minutes.textContent = pad(minutes);
      if (this.units.seconds) this.units.seconds.textContent = pad(seconds);
      if (this.status && seconds === 0) {
        this.status.textContent = days + ' days, ' + hours + ' hours, ' + minutes + ' minutes remaining.';
      }
    }

    // Nothing left to count once it has ended, and a forced preview never moves.
    if (state === 'ended' || this.preview !== 'auto') return;
    setTimeout(function () { self.tick(); }, 1000 - (Date.now() % 1000));
  };

  Campaign.prototype.apply = function (state) {
    if (state === this.state && this.applied) return;
    this.state = state;
    this.applied = true;
    this.root.setAttribute('data-state', state);

    var hide = (state === 'pre' && !this.showPre) || (state === 'ended' && !this.showEnded);
    if (this.preview !== 'auto') hide = false;
    this.root.hidden = hide;

    Array.prototype.forEach.call(this.root.querySelectorAll('[data-dmh-when]'), function (node) {
      var states = node.getAttribute('data-dmh-when').split(' ');
      node.hidden = states.indexOf(state) === -1;
    });

    if (this.label && this.labels[state]) this.label.textContent = this.labels[state];

    this.syncTrustStrip(!hide && (state === 'live' || state === 'final'));
  };

  Campaign.prototype.syncTrustStrip = function (hideStrip) {
    if (!this.trustAnchor) return;
    var rule = document.querySelector('style[data-dmh-trust-hide]');
    if (hideStrip && !rule) {
      rule = document.createElement('style');
      rule.setAttribute('data-dmh-trust-hide', '');
      rule.textContent = '#' + CSS.escape(this.trustAnchor) + ' { display: none !important; }';
      this.root.parentNode.insertBefore(rule, this.root);
    } else if (!hideStrip && rule) {
      rule.parentNode.removeChild(rule);
    }
  };

  function boot(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-dmh-campaign]'), function (root) {
      if (!root.__dmhCampaign) root.__dmhCampaign = new Campaign(root);
    });
  }

  boot(document);
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})();
